import {
  CAlert, CButton, CContainer, CForm, CFormGroup,
  CInput, CLabel, CModal, CModalBody, CModalFooter, CModalHeader,
  CModalTitle, CRow, CTextarea
} from '@coreui/react';
import firebase from 'firebase';
import React, { useEffect, useState } from 'react';
import { fs } from '../../firebase';
import Notify from '../../utils/Notify';
import { Editor } from '@tinymce/tinymce-react'

export default function AddPageModal(props) {
  const pageModel = {
    id: '',
    name: '',
    content: '',
    createdAt: firebase.firestore.Timestamp.now()
  }
  const [page, setPage] = useState(pageModel)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleAddPage() {
    setError('')
    if (!page.name) {
      setError('Please enter Page name')
      return;
    }

    setLoading(true)
console.log(page)
    try {
      if (props.page) {
        await fs.collection('pages').doc(page.id).set(page)
      } else {
        var docRef = await fs.collection('pages').add(page)
        await fs.collection('pages').doc(docRef.id).set({ ...page, id: docRef.id })
      }

      props.onClose()
      let message = 'Page added successfully.'

      if (props.page) {
        message = 'Page updated successfully.'
      }
      Notify.success(message)
    } catch (error) {
      console.log(error)
      setError('Something went wrong. Please try again.')
      setLoading(false)
    }
  }

  useEffect(() => {
    if (props.page) {
      setPage(props.page)
    }
  }, [])

  return (
    <CModal
      size={'lg'}
      show={props.show}
      centered={false}
      onClose={() => props.onClose()}
      className="border-dark"
    >
      <CModalHeader closeButton>
        <CModalTitle>{props.page ? 'Edit' : 'Add'} Page</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow >
            {
              error && <CAlert color="danger" className="w-100">{error}</CAlert>
            }
            <CForm className="w-100"
              onSubmit={e => {
                e.preventDefault()
                handleAddPage()
              }}>
              <CFormGroup className="w-100">
                <CLabel>Page Name</CLabel>
                <CInput
                  className="w-100"
                  value={page.name}
                  type="text"
                  placeholder="Enter page name"
                  onChange={(e) => setPage({ ...page, name: e.target.value })}
                />
              </CFormGroup>
              <CFormGroup className="w-100">
                <CLabel>Page Content</CLabel>
                {/* <CTextarea
                  className="w-100"
                  value={page.content}
                  placeholder="Enter content"
                  rows={'20'}
                  onChange={(e) => setPage({ ...page, content: e.target.value })}
                /> */}

                <Editor
                  apiKey='8du22d1rgtzml7ttob3l47ykfhjnv9fbwd38x4op0i50ddup'
                  onInit={(evt, editor) => { }}
                  initialValue={page.content}
                  init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | ' +
                      'bold italic backcolor | alignleft aligncenter ' +
                      'alignright alignjustify | bullist numlist outdent indent | ' +
                      'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                  }}
                  onChange={(value, editor) => {
                    // console.log(value.level.content)
                    setPage({ ...page, content: value.level.content })
                  }}
                />

              </CFormGroup>
            </CForm>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton color="danger" variant="outline" className="btn-sm pl-2 pr-2"
          disabled={loading}
          onClick={() => props.onClose()}>Cancel</CButton>
        <CButton color="dark" className="btn-sm pl-4 pr-4" type="submit"
          disabled={loading}
          onClick={(e) => {
            e.preventDefault()
            handleAddPage()
          }
          }>Save</CButton>
      </CModalFooter>
    </CModal>
  )
}
